import React from 'react';
import { hasLabLogo } from '../../utils/labLogo';
import './LabLogoBadge.css';

const FALLBACK_EMOJI = '🧪';

/**
 * Round lab avatar — logo image or fallback emoji.
 *
 * @param {Object} props
 * @param {Object|null|undefined} props.lab - Current lab from AppContext.
 * @param {'sm'|'md'} [props.size='sm']
 * @param {string} [props.className]
 * @param {() => void} [props.onLogoError] - Called when img fails (presigned URL expiry).
 */
const LabLogoBadge = ({
  lab,
  size = 'sm',
  className = '',
  onLogoError,
}) => {
  const sizeClass = size === 'md' ? 'lab-logo-badge--md' : 'lab-logo-badge--sm';
  const showLogo = hasLabLogo(lab);

  return (
    <span
      className={`lab-logo-badge ${sizeClass}${className ? ` ${className}` : ''}`}
      aria-hidden={showLogo ? undefined : true}
    >
      {showLogo ? (
        <img
          src={lab.logo_url}
          alt=""
          className="lab-logo-badge__img"
          onError={() => {
            if (onLogoError) {
              onLogoError();
            }
          }}
        />
      ) : (
        <span className="lab-logo-badge__emoji">{FALLBACK_EMOJI}</span>
      )}
    </span>
  );
};

export default LabLogoBadge;
